import { createAsyncThunk } from '@reduxjs/toolkit';
import { ExtraReducer, getSideEffectState } from '@utils/.';
import { BookingReducerProps } from '../type';
import { bookingApiService } from '@services/service-register';
import { RestaurantReservationParams } from '@core/models';

export const fetchReservationsSilent = createAsyncThunk(
  'booking/fetchReservationsSilent',
  async (_, thunkApi) => {
    try {
      const reservations =
        await bookingApiService.getLocationReservations<RestaurantReservationParams>();
      return reservations;
    } catch (e: any) {
      return undefined;
    }
  }
);

const [fulfilled, rejected] = getSideEffectState(fetchReservationsSilent);

export const fetchReservationsSilentReducer = {
  [fulfilled]: (state, action) => {
    state.reservations = action.payload || [];
  },
  [rejected]: (state, action) => {
    state.reservations = [];
  },
} as ExtraReducer<BookingReducerProps>;
